const rtlLocales = ['ar', 'he', 'iw', 'fa', 'ur', 'ps', 'sd', 'yi']

export function useRtlLocaleCheck(locale: string): boolean {
  if (!locale) throw new Error('no locale set')

  const baseLocale = locale.split('-')[0].toLowerCase()
  return rtlLocales.includes(baseLocale)
}
